/**
 * @description This file serves as the entry point for the entire application. The browser router is mounted to the DOM and then, depending on the user's URL, a specific page
 * component is mounted and displayed.
 */

import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter, Outlet } from 'react-router-dom';

import routes from '@seccon/core/routes';
import App from '@seccon/core/components/App';
import NotFound from '@seccon/core/components/NotFound';

// Defines the router for the application
const router = createBrowserRouter([
  {
    children: [
      // These routes define navigation structure of the entire application. Depending on the user's url a specific page component will be served
      ...routes,

      // If no route matches, serve a 404 page
      {
        path: '*',
        element: (
          <NotFound />
        )
      }
    ],
    // Each page is wrapped by the App component, which provides things like general layout, navigation, data providers, and other platform support features.
    element: (
      <App>
        <Outlet />
      </App>
    )
  }
]);

// Mount the router to the DOM
ReactDOM.createRoot(document.querySelector('#seccon')).render(<RouterProvider router={router} />);
